import { IsEmail, IsOptional, MinLength } from 'class-validator';
import { action, observable } from 'mobx';
import { observer } from 'mobx-react';
import * as React from 'react';
import { Component } from 'react';
import { Link } from 'react-router-dom';
import { UserApi } from '@intelingu/core/api/UserApi';
import { COMMON_NS } from '@intelingu/core/constants/base.constants';
import { IsEqualTo } from '@intelingu/core/validators/decorators/IsEqualTo';
import { lazyInject } from '@intelingu/core/IoC/container';
import { UserStore } from '@intelingu/core/stores/UserStore';
import Logger from '@intelingu/core/utils/Logger';
import withTranslation from '@intelingu/core/utils/withTranslation';
import { SubmitButton } from '../../../../partials/form/elements/SubmitButton';
import { TextInput } from '../../../../partials/form/elements/TextInput';
import { Field } from '@intelingu/core/components/form/Field';
import { Form } from '@intelingu/core/components/form/Form';

export interface EditCredentialsTabProps {
    t?;
}

class CredentialsRequest {

    @IsEmail()
    email: string;

    @MinLength(6)
    @IsOptional()
    password: string;

    @IsEqualTo('password', {
        message: 'passwords are not equal'
    })
    password_repeat: string;

}

@withTranslation(COMMON_NS)
@observer export class EditCredentialsTab extends Component<EditCredentialsTabProps, any> {

    @lazyInject(UserStore) userStore: UserStore;
    @lazyInject(UserApi) userApi: UserApi;

    @observable isDone = false;
    @observable errorMessage;

    @action.bound async update(data: CredentialsRequest, done) {
        try {
            this.errorMessage = undefined;
            await this.userApi.update(data);
            await this.userStore.loadProfile();

            this.isDone = true;
        } catch (e) {
            this.errorMessage = e.response.data.message;

            Logger.error(e);
        } finally {
            done();
        }
    }

    render() {
        const { t } = this.props;

        return <>
            <div className={'tab-title'}>
                <h3 className={'tab-title'}>{ t('credentialsFormTitle') }</h3>
                <p>{ t('credentialsFormSubtitle') }</p>
            </div>

            <Form
                validator={CredentialsRequest}
                defaultData={{
                    email: this.userStore.user.email
                }}
                onSubmit={this.update}
            >
                <div className={'form-group'}>
                    <label htmlFor="email">{ t('sessionEmail') }</label>

                    <Field name={'email'} render={props => <TextInput type={'email'} {...props} />} />
                </div>

                <div className={'form-group'}>
                    <label htmlFor="password_old">{ t('sessionPassword') }</label>

                    <Field name={'password_old'} render={props => <TextInput type={'password'} {...props} />} />
                </div>

                <div className={'form-group'}>
                    <label htmlFor="password">{ t('sessionNewPassword') }</label>

                    <Field name={'password'} render={props => <TextInput type={'password'} {...props} />} />
                </div>

                <div className={'form-group'}>
                    <label htmlFor="password_repeat">{ t('sessionRepeatPassword') }</label>

                    <Field name={'password_repeat'} render={props => <TextInput type={'password'} {...props} />} />
                </div>

                { this.isDone && <div className={'alert alert-success'}>{ t('credentialsUpdatedMessage') }</div> }
                { this.errorMessage && <div className={'alert alert-danger'}>{ this.errorMessage }</div> }

                <Field submit render={props => <SubmitButton {...props}>{ t('credentialsConfirmChangesButton') }</SubmitButton>} />

                <div className={'mt-3 mb-3'}>
                    <Link to={`/session/reset`} className={'red'}>{ t('sessionForgotPasswordLink') }</Link>
                </div>
            </Form>
        </>
    }

}
